import { Input, FormGroup } from 'reactstrap';

function CustomInput({
  id,
  label,
  inline,
  type,
  className,
  children,
  ...rest
}) {
  if (type === 'switch' || type === 'checkbox' || type === 'radio') {
    return (
      <FormGroup
        check
        inline={inline}
        switch={type === 'switch' || undefined}
        className={className}
      >
        <Input id={id} type={type} {...rest} />
        {label != null && (
          <label className="form-check-label" htmlFor={id}>
            {label}
          </label>
        )}
      </FormGroup>
    );
  }
  return (
    <Input id={id} type={type} className={className} {...rest}>
      {children}
    </Input>
  );
}

export default CustomInput;
